import { Colors, Services } from '@sigma-frontend-libs/commons'

import { buttonModes, components, getISODate, getYesterday, icons, sizes } from '@/utils'

import button from '@/components/button'
import { scheduleTypes } from '@/components/services/sendingsCreate/schedule'
import sticker from '@/components/sticker'

function renderTitle(h) {
  return h(
    'div',
    {
      class: `${Services.sendings}-create__schedule-title`
    },
    [ this.getTranslate(`${Services.sendings}.titles.schedule`) ]
  )
}
function renderDateSticker(h) {
  return h(
    sticker,
    {
      props: {
        value: this.formatDelay,
        label: this.getTranslate(`${Services.sendings}.labels.schedule.delay`),
        icon: icons.event,
        color: Colors.grey,
        width: '100%',
        to: { service: undefined },
        button: {
          icon: icons.clear,
          mode: buttonModes['flat-icon'],
          color: Colors.grey,
          disabled: !this.changeableDates.delay.date,
          callback: () => {
            return this.setDefaultSchedule()
          }
        }
      },
      slot: 'activator'
    }
  )
}
function renderDatePicker(h) {
  return h(
    components.card,
    {
      props: {
        title: this.getTranslate(`${Services.sendings}.labels.date`),
        outline: true,
        rounded: true
      }
    },
    [
      h(
        components['date-picker'],
        {
          props: {
            value: this.changeableDates.delay.date,
            localeTag: this.locale,
            min: getYesterday(),
            range: false,
            filter: dates => {
              return dates.map(date => {
                return date && getISODate(date)
              })
            }
          },
          on: {
            input: event => {
              this.changeableDates.delay.date = event
            }
          }
        }
      )
    ]
  )
}
function renderTimeField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.changeableDates.delay.time,
        label: this.getTranslate(`${Services.sendings}.labels.time`),
        type: 'time',
        details: false,
        dense: true
      },
      on: {
        input: event => {
          this.changeableDates.delay.time = event
        }
      }
    }
  )
}
function renderDateMenuFooter(h) {
  return h(
    'div',
    {
      class: `${Services.sendings}-create__schedule-menu-footer`
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.clear'),
            mode: buttonModes.flat,
            disabled: !this.changeableDates.delay.date,
            size: sizes.small
          },
          on: {
            click: () => {
              return this.setDefaultSchedule()
            }
          }
        }
      ),

      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.close'),
            mode: buttonModes.flat,
            size: sizes.small
          },
          on: {
            click: () => {
              this.show = false
            }
          }
        }
      )
    ]
  )
}
function renderDateMenu(h) {
  return h(
    'div',
    {
      class: `${Services.sendings}-create__schedule-menu`
    },
    [
      renderDatePicker.call(this, h),
      renderTimeField.call(this, h),
      renderDateMenuFooter.call(this, h)
    ]
  )
}
function renderFieldDate(h) {
  return h(
    components.menu,
    {
      props: {
        value: this.show,
        closeOnContentClick: false,
        rounded: true
      },
      on: {
        show: event => {
          this.show = event
        }
      }
    },
    [
      renderDateSticker.call(this, h),
      renderDateMenu.call(this, h)
    ]
  )
}
function renderUntilField(h) {
  return h(
    components.select,
    {
      props: {
        value: this.changeableDates.until,
        label: this.getTranslate(`${Services.sendings}.labels.schedule.until`),
        items: this.untilItems,
        disabled: !this.changeableDates.delay.date,
        required: true,
        details: false,
        dense: true
      },
      on: {
        input: event => {
          this.changeableDates.until = event
        }
      }
    }
  )
}
function renderFields(h) {
  if (this.scheduleType === scheduleTypes.latter) {
    return h(
      'div',
      {
        class: `${Services.sendings}-create__schedule-fields`
      },
      [
        renderFieldDate.call(this, h),
        renderUntilField.call(this, h)
      ]
    )
  }
}

function renderScheduleTypeSelect(h) {
  return h(
    'div',
    {
      class: `${Services.sendings}-create__schedule-type`
    },
    [
      Object.values(scheduleTypes).map(type => {
        return h(
          components.radio,
          {
            props: {
              value: this.scheduleType,
              defaultValue: type,
              label: this.getTranslate(`${Services.sendings}.schedule.types.${type}`)
            },
            on: {
              input: event => {
                this.scheduleType = event
              }
            }
          }
        )
      })
    ]
  )
}

export default function(h) {
  return h(
    components.card,
    {
      class: `${Services.sendings}-create__schedule`,
      props: {
        outline: true,
        flat: true,
        rounded: true
      }
    },
    [
      renderTitle.call(this, h),
      renderScheduleTypeSelect.call(this, h),
      renderFields.call(this, h)
    ]
  )
}
